import styled from '@emotion/styled'
import { Button } from '@mui/material'

export const ButtonStyled = styled(Button)``
